import styled from 'styled-components';
import fonts from '../../../../../helpers/fonts';
import spacing from '../../../../../helpers/spacing';

const ExplanatoryText = styled.p`
  ${fonts.paragraph};

  padding-right: ${spacing(1)};
  display: inline;
  vertical-align: middle;

  &::before {
    content: '';
    display: block;
  }
`;

export default ExplanatoryText;
